import "./patches/reactstrap-patch";
import "bootstrap/dist/css/bootstrap.min.css";
import "@zambezi/sdk-themes/zb-champion-standard/theme.min.css";
import "@zambezi/sdk-themes/zb-champion-standard/icons";
import "react-datepicker/dist/react-datepicker.css";
import { createContext } from "react";
import { App } from "./App";
import * as serviceWorker from "./serviceWorker";
import { Store } from "./state/store";
import { dxApx } from "./tracking";
import { brand, env, envSettings, getVersion } from "./services/envService";
import { createRoot } from "react-dom/client";
const BRAND = brand();

require(`./style/${BRAND}/index.scss`);

const store = new Store();
export const AppContext = createContext<Store>(new Store());
dxApx();
const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <AppContext.Provider value={store}>
    <App />
  </AppContext.Provider>
);

serviceWorker.unregister();

console.group(`${env()}@${getVersion()}`);
console.log(JSON.stringify(envSettings(), null, 2));
console.groupEnd();
